<template>
  <div class="knowledge">

    <div class="banner">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="item in swipeList" :key="item.id" class="item">
          <img :src="item.img" alt class="pic" @click="goDetail(item.urlInfo)"/>
        </swiper-slide>
      </swiper>
    </div>

    <div class="box" v-for="(item,index) in content" :key="index">
      <div class="box-header">
        <h2 class="box-title">{{ item.sub_title }}</h2>
      </div>

      <div class="box-content">
        <div class="box-item" v-for="item2 in item.content_list" :key="item2.id">
          <!-- :href='{% if tsg_channel %}item2.uri + '?channel={{tsg_channel}}'{% else %}item2.uri{% endif %}'  -->
          <a class="box-item-pic" @click="goDetail(item2)">
            <img :src="item2.img" alt="口袋故事">
          </a>
          <div class="box-item-name">{{ item2.title }}</div>
        </div>
      </div>

    </div>


  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import lunYuImg from '@/assets/knowledge/lunyu.jpg'
import qiMengImg from '@/assets/knowledge/qimeng.jpg'
import tingTingImg from '@/assets/knowledge/tingting.jpg'
import tangShiImg from '@/assets/knowledge/tangshi.jpg'
import historyImg from '@/assets/knowledge/history.jpg'
import scienceImg from '@/assets/knowledge/science.jpg'
// require('../../assets/global/avatar.png')
import courseData from './course_data'

console.log(courseData)
export default {
  components: {
    Swiper,
    SwiperSlide,
  },

  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: true,
        // 用户操作swipe之后，是否禁止autoplay
        autoplayDisableOnInteraction : false,
      },
      swipeList: [
        {id: 1, img: require('../../assets/knowledge/11172.jpg'), urlInfo: {tag: 'course', id: 11172} },
        {id: 2, img: require('../../assets/knowledge/10112.jpg'), urlInfo: {tag: 'course', id: 10112} },
        {id: 3, img: require('../../assets/knowledge/10788.jpg'), urlInfo: {tag: 'course', id: 10788} },
        {id: 4, img: require('../../assets/knowledge/12521.jpg'), urlInfo: {tag: 'course', id: 12521} },
        {id: 5, img: require('../../assets/knowledge/12925.jpg'), urlInfo: {tag: 'course', id: 12925} },
        {id: 6, img: require('../../assets/knowledge/10846.jpg'), urlInfo: {tag: 'course', id: 10846} },
      ],
      content: courseData
    }
  },

  computed: {},
  created() {},

  methods: {
    goDetail (audio) {
      // const audioUrl = audio.uri
      // window.location.href = `ilisten:///course/info?id=${audioUrl}&position=` // position不可少(不然安卓打不开)
      // console.log('audio', type, audioId)

      let { tag: type, id: audioId }= audio
      window.location.href = `ilisten:///${type}/info?id=${audioId}&position=`   //position不可少(不然安卓打不开)
    },

  },
}
</script>

<style lang='less' scoped>
@import '~@/styles/fn';
@import url('./css/swiper.css');

body {
  margin: 0 auto;
  font-family: 'Arial','Microsoft YaHei','黑体','宋体',sans-serif;
  font-size: 16px;
}

// 兼容iPhone5等较小机型
@media screen and (max-width: 350px) {
  html {
    font-size: 270%;
  }
}


.knowledge {
  background: #FFF;
  min-height: 100vh;
  max-width: 450px;
  margin: 0 auto;
  padding-bottom: 96px;
  box-sizing: border-box;
  box-shadow: 0 .04rem .18rem 0 rgba(0, 0, 0, 0.16);
}

.banner{
  padding: 16px 16px 0 16px;
  .pic {
    width: 100%;
    height: auto;
    border-radius: 4px;
  }
}

.box {
  padding: 16px 16px 0 16px;
  .box-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .box-title {
      font-size: 16px;
      color: #6C6C73;
      font-weight: bold;
    }

  }
  .box-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-top: 12px;
    .box-item {
      margin-bottom: 12px;
      width: 31%;
      &-pic {
        display: inline-block;
        width: 106px;
        height: 106px;
        border-radius: 4px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &-name {
        max-width: 106px;
        margin-top: 4px;
        font-size: 14px;
        color: #6C6C73;
        // 溢出部分省略号
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      &-desc {
        max-width: 106px;
        margin-top: 1px;
        font-size: 9px;
        color: #6C6C73;
      }
    }
    &:after{
      content: '';
      width: 30%;
    }
  }
}

</style>
